import { VideoModal } from '../components/video_modal.js';

export class ArticlesLanding extends DrupalBehavior {
  onContent(context) {
    nakedFormSelect('select#edit-topic', {
      context: {
        value: context,
      },
    });

    let filterSelect = context.querySelector('#edit-topic');
    let keywordSearch = context.querySelector('#edit-keyword');

    if (filterSelect) {
      filterSelect.addEventListener('change', function (e) {
        // Empty out the keyword field before searching for a topic.
        if (keywordSearch) {
          keywordSearch.value = '';
        }
        e.target.closest('form').submit();
      });
    }

    if (keywordSearch) {
      keywordSearch.addEventListener('keydown', function (e) {
        if (e.keyCode === 13) {
          e.preventDefault();
          e.target.closest('form').submit();
        }
      });
    }

    var videoModal = new VideoModal();
    var videos = context.querySelectorAll(
      '.article--teaser--video, .article--search-result--video, .featured-article__video'
    );
    videoModal.init(videos);
  }
}

DrupalBehavior.register(
  'rush_theme.pages',
  'articles_landing',
  ArticlesLanding
);
